/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Delete_Empty_FolderInputs */

const en_dialog_delete_empty_folder = /** @type {(inputs: Dialog_Delete_Empty_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete empty folder`)
};

const es_dialog_delete_empty_folder = /** @type {(inputs: Dialog_Delete_Empty_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar carpeta vacía`)
};

/**
* | output |
* | --- |
* | "Delete empty folder" |
*
* @param {Dialog_Delete_Empty_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_empty_folder = /** @type {((inputs?: Dialog_Delete_Empty_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_Empty_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_empty_folder(inputs)
	return en_dialog_delete_empty_folder(inputs)
});